module.exports = __webpack_public_path__ + "static/media/DK.85d27644.svg";